import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

export const CreateCircleDialog = ({ open, onOpenChange, name, setName, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="surface-card max-w-sm">
      <DialogHeader>
        <DialogTitle>Create Your Circle</DialogTitle>
        <DialogDescription>Give your support circle a name.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <Input
          placeholder="e.g., Jordan's Care Circle"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="rounded-xl"
          data-testid="circle-name-input"
          autoFocus
        />
        <Button
          onClick={onSubmit}
          className="w-full bg-gradient-to-r from-cyan-600 to-emerald-600 hover:from-cyan-700 hover:to-emerald-700 text-white"
          data-testid="submit-create-circle"
        >
          Create Circle
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
